import {FC, useState} from 'react'
import {Card, Container} from 'react-bootstrap'
import {useSelector} from 'react-redux'
import {useSmppUserChangePasswordMutation} from '../../../../../services/cellcast.v2'
import {SmppStatus} from '../../../../../services/cellcast.v2.types'
import ChangePasswordPopup from '../../../../Components/ChangePasswordPopup'
import {getAllUserDetails} from '../Overview/OverviewSlice/UserDetailsSlice'

const SmppCard: FC = () => {
  const profileDetailState = useSelector(getAllUserDetails)

  const [changePassword] = useSmppUserChangePasswordMutation()
  const [showChangePasswordModel, setShowChangePasswordModal] = useState(false)

  const changePasswordHandler = async (
    password: string
  ): Promise<{
    isSuccess: boolean
    message: string
  }> => {
    const result = await changePassword({
      password,
    })

    if ('data' in result) {
      if (result.data?.error && Object.keys(result.data?.error).length > 0) {
        return {isSuccess: false, message: result?.data?.message}
      } else {
        return {isSuccess: true, message: result?.data?.message}
      }
    } else if ('error' in result) {
      const resError = result.error as any
      let message = result?.error.toString()
      if (resError.data?.message) {
        message = resError.data?.message || ''
      }
      return {isSuccess: false, message: message}
    }

    return {isSuccess: true, message: ''}
  }

  return (
    <div className={`card mb-6`}>
      <ChangePasswordPopup
        handleClose={() => setShowChangePasswordModal(false)}
        handleSubmit={changePasswordHandler}
        show={showChangePasswordModel}
      />
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Smpp Server</span>
        </h3>
      </div>
      <div className='card-body py-3'>
        {profileDetailState.smppStatus === undefined ||
          (profileDetailState.smppStatus && profileDetailState.smppStatus !== SmppStatus.Active && (
            <Container style={styles.container}>
              <h2>SMPP account is not active</h2>
            </Container>
          ))}

        {profileDetailState.smppStatus && profileDetailState.smppStatus === SmppStatus.Active && (
          <>
            <div className='row mb-2 mt-5'>
              <div className='col-md-3'>
                <label>
                  <b>Username</b>{' '}
                </label>
              </div>
              <div className='col-md-6'>{profileDetailState.smppAuth?.username}</div>
            </div>
            <div className='row mb-2 mb-5'>
              <div className='col-md-3'>
                <label>
                  <b>Status</b>
                </label>
              </div>
              <div className='col-md-6'>
                <span
                  className={`badge badge-light-${
                    profileDetailState.smppStatus === SmppStatus.Active ? 'success' : 'danger'
                  }`}
                >
                  {profileDetailState.smppStatus === SmppStatus.Active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            <div className='col d-flex justify-content-start mb-10 mt-5'>
              <button
                className='btn btn-sm btn-primary'
                onClick={() => setShowChangePasswordModal(true)}
              >
                Change Password
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

// Inline styles to center the button
const styles = {
  container: {
    display: 'flex', // Flexbox for centering
    justifyContent: 'center', // Horizontally center
    alignItems: 'center', // Vertically center
    height: '20vh', // Full viewport height
  },
}

export default SmppCard
